import React from "react";
import "./style.css";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalHeader, ModalContent, ModalFooter, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import { CloseIcon } from "../../../Assets/images/svgs";

const CustomPopUpModal = ({ modalBody, modalTitle, closeBtn, confirmBtn, open, onModalClose, onConfirm, size, footer, startBtn, onStart, customClose, modalId, contentClassName="", bodyClassName="", showCrossBtn=false }) => {
  const { onClose } = useDisclosure();

  const handleModalClose = () => {
    onClose();
    onModalClose();
  };

  return (
    <div className="custom-pop-up-modal">
      <Modal
        id={modalId || "custom-modal"}
        isOpen={open}
        onClose={handleModalClose}
        isCentered
        size={size || "md"}
      >
        <ModalOverlay />

        <ModalContent className={`c-modal-content ${contentClassName}`}>
        {modalTitle && <ModalHeader className="c-modal-header">{modalTitle}</ModalHeader>}

          {modalBody && <ModalBody className={`c-modal-body ${bodyClassName}`}>
            {modalBody}
            {showCrossBtn && <CloseIcon className="c-modal-close-btn" onClick={() => handleModalClose()} />}
          </ModalBody>}

         { (closeBtn || confirmBtn || startBtn) ? <ModalFooter className={`c-modal-footer ${footer}`}>
            <div className="c-modal-btn-grp">
              {closeBtn && (
                <Button
                  onClick={customClose || handleModalClose}
                  className="popup-modal-close-button"
                >
                  {closeBtn}
                </Button>
              )}
              {confirmBtn && (
                <Button
                  variant="ghost"
                  onClick={() => onConfirm()}
                  className="popup-modal-confirm-button"
                >
                  {confirmBtn}
                </Button>
              )}
              {startBtn && (
                <Button
                  variant="ghost"
                  onClick={onStart}
                  className="popup-modal-confirm-button"
                >
                  {startBtn}
                </Button>
              )}
            </div>
          </ModalFooter> : null}
        </ModalContent>
      </Modal>
    </div>
  );
};

CustomPopUpModal.propTypes = {
  open: PropTypes.bool,

  size: PropTypes.string,
  modalMsg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.number,
  ]),
  footer: PropTypes.string,
  showInput: PropTypes.bool,
  inputCover: PropTypes.string,
  placeholder: PropTypes.string,

  closeBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
  onConfirm: PropTypes.func,
  onModalClose: PropTypes.func,

  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default CustomPopUpModal;
